import { TableCell, TableRow } from '@mui/material'
import React, { useEffect, useState } from 'react'
// import { unitMeasureShortText } from '../../../../../../../../../helpers/unitMeasure/UnitMeasureHelper'
import SupplyBillItemCountField from './fileds/SupplyBillItemCountField'
import { formDataProductIsField, formDataProductRequiredField } from '../../../../../../../../../helpers/form/FormData'
import { checkValid, setValueForm, updateValidate } from '../../../../../../../../../helpers/form/FormHelper'
import { useSelector } from 'react-redux'

const SupplyBillItem = ({ item, setValidate, setValueFormItem }) => {

    const unitMeasures = useSelector(state => state.settings.unitMeasures)
    const unitMeasure = unitMeasures && unitMeasures[item.unitMeasure] ? unitMeasures[item.unitMeasure].name : '?'

    const [data, setData] = useState(item ? item : {}) // Дані з форми

	const [valid, setValid] = useState({}) // Валідація кожного поля

    useEffect(() => {
        setValueMax()
    }, [])

	useEffect(() => {
		checkValid(valid, setValidate)
	}, [valid])

	useEffect(() => {
		if (data) {
			setValueFormItem(data)
		}
	}, [data])

    const setValueMax = () => {
        // if (!data.countInBill) {
            setValueForm(setData, 'countInBill', data.countFree)
        // }
    }

  return (
    <TableRow>
        <TableCell align='center' className='wordBreakAll'>
            {
				item.name
			}
        </TableCell>
        <TableCell align='center' className='supplyBillItem__count'>
            {
                formDataProductIsField('count', 'supplyBillItem') ?
                    <SupplyBillItemCountField
                        item={data}
                        required={formDataProductRequiredField('count', 'supplyBillItem')}
                        setValidate={e => updateValidate(setValid, 'countInBill', e)}
                        // setValidate={e => checkValidCount(e)}
                        setValueForm={e => setValueForm(setData, 'countInBill', e)}
                        forciblyValue={
                            // data && data.countFree ? data.countFree  : 
                            // data && data.countInBill ? data.countInBill : ''
                            data && data.countInBill ? data.countInBill : ''
                        }
                    />
                : ''
            }
        </TableCell>
        <TableCell align='center'>
            {
				// item.count + ' ' + unitMeasureShortText[item.unitMeasure]
				// item.countFree + ' ' + unitMeasureShortText[item.unitMeasure]
				item.countFree + ' ' + unitMeasure
			}
        </TableCell>
    </TableRow>
  )
}

export default SupplyBillItem